


































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import { Paciente } from '../../../../back/src/entity/Paciente';
import {
  SimNao,
  PacienteFormExternoEtapa1,
  PacienteFormExternoEtapa2,
  PacienteFormExternoEtapa3,
  PacienteFormExternoEtapa4,
  PacientePostFormData,
} from '../../../../back/src/types';

import Requester from '../../requester';
import ThePacientesCadastroExternoEtapa1 from '../../components/pacientes/ThePacientesCadastroExternoEtapa1.vue';
import ThePacientesCadastroExternoEtapa2 from '../../components/pacientes/ThePacientesCadastroExternoEtapa2.vue';
import ThePacientesCadastroExternoEtapa3 from '../../components/pacientes/ThePacientesCadastroExternoEtapa3.vue';
import ThePacientesCadastroExternoEtapa4 from '../../components/pacientes/ThePacientesCadastroExternoEtapa4.vue';
import { TextoEditavel } from '../../../../back/src/entity/TextoEditavel';
import { dataBrToDate } from '../../utils/functions';


export default Vue.extend({
  name: 'PacientesCadastroExterno',
  components: {
    ThePacientesCadastroExternoEtapa1,
    ThePacientesCadastroExternoEtapa2,
    ThePacientesCadastroExternoEtapa3,
    ThePacientesCadastroExternoEtapa4,
  },
  data() {
    return {
      textoInicialId: 1,
      textoInicial: Object as () => TextoEditavel,
      textoFinalId: 2,
      textoFinal: Object as () => TextoEditavel,
      loading: false,
      step: 0,
      formEtapa1: {} as PacienteFormExternoEtapa1,
      formEtapa2: {} as PacienteFormExternoEtapa2,
      formEtapa3: {} as PacienteFormExternoEtapa3,
      formEtapa4: {} as PacienteFormExternoEtapa4,
    };
  },
  mounted() {
    this.getTextoInicial();
    this.getTextoFinal();
  },
  methods: {
    changeStep(step: number) {
      this.step = step;
      window.scrollTo(0, 0);
    },
    etapaValida1(form: PacienteFormExternoEtapa1) {
      this.formEtapa1 = form;
      this.changeStep(2);
    },
    etapaValida2(form: PacienteFormExternoEtapa2) {
      this.formEtapa2 = form;
      this.changeStep(3);
    },
    etapaValida3(form: PacienteFormExternoEtapa3) {
      this.formEtapa3 = form;
      this.changeStep(4);
    },
    etapaValida4(form: PacienteFormExternoEtapa4) {
      this.formEtapa4 = form;
      this.submitForm();
    },
    async getTextoInicial() {
      try {
        const response = await Requester.textoEditavel.textoEditavel(this.textoInicialId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.textoInicial = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      }
    },
    async getTextoFinal() {
      try {
        const response = await Requester.textoEditavel.textoEditavel(this.textoFinalId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.textoFinal = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      }
    },
    async submitForm() {
      this.loading = true;
      const formData: PacientePostFormData = {
        cpf: this.formEtapa1.cpf,
        nome: this.formEtapa2.nome,
        email: this.formEtapa2.email,
        tipo_telefone1: this.formEtapa2.tipoTelefone1,
        telefone1: this.formEtapa2.telefone1,
        tipo_telefone2: this.formEtapa2.tipoTelefone2,
        telefone2: this.formEtapa2.telefone2,
        rg: this.formEtapa2.rg,
        data_nascimento: dataBrToDate(this.formEtapa2.dataNascimento),
        profissao: this.formEtapa2.profissao,
        escolaridade: this.formEtapa2.escolaridade,
        estado_civil: this.formEtapa2.estadoCivil,
        estado_civil_outro: this.formEtapa2.estadoCivilOutro,
        cep: this.formEtapa3.cep,
        logradouro: this.formEtapa3.logradouro,
        numero: this.formEtapa3.numero,
        complemento: this.formEtapa3.complemento,
        bairro: this.formEtapa3.bairro,
        cidade: this.formEtapa3.cidade,
        estado: this.formEtapa3.estado,
        pais: this.formEtapa3.pais,
        como_conheceu: this.formEtapa4.como_conheceu,
        condicoes_especiais: this.formEtapa4.condicoesEspeciais,
      };
      if (this.formEtapa4.planoSaude === SimNao.S) {
        const novoPlanoDeSaude = {
          nome: this.formEtapa4.nomePlanoSaude,
          tipo: this.formEtapa4.tipoPlanoSaude,
          fim_carencia: this.formEtapa4.fimCarenciaParto,
          preferido: true,
        };
        _.assign(formData, { planos_de_saude: [novoPlanoDeSaude] });
      }
      if (this.formEtapa4.gestacao === SimNao.S) {
        const novaGestacao = {
          atual: true,
          dpp_final: null,
          data_ultima_menstruacao: this.formEtapa4.dataUltimaMenstruacao
            ? moment(this.formEtapa4.dataUltimaMenstruacao).toDate()
            : null,
          data_provavel_parto: this.formEtapa4.dataProvavelParto
            ? moment(this.formEtapa4.dataProvavelParto).toDate()
            : null,
        };
        _.assign(formData, { gestacoes: [novaGestacao] });
      }
      try {
        const response = await Requester.paciente.criaPacienteExterno(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$store.dispatch('resetPacienteFormExterno');
          this.changeStep(5);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
});
